var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Print(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-print",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M14,18H4a2,2,0,0,1-2-2V12H.5a.5.5,0,0,1-.5-.5V6A2,2,0,0,1,2,4V2A2,2,0,0,1,4,0H14a2,2,0,0,1,2,2V4a2,2,0,0,1,2,2v5.5a.5.5,0,0,1-.5.5H16v4A2,2,0,0,1,14,18ZM4,10v6H14V10ZM14.5,6a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5ZM4,2V4H14V2Z",
    transform: "translate(3 3)",
    fill: "#1dbbbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Print);
export default __webpack_public_path__ + "static/media/icon-24-print.04e7970cb9925a51e813272735a935f3.svg";
export { ForwardRef as ReactComponent };